import React, { useState } from 'react';

import ComptesUtilisateursFilterProvider from 'hooks/FilterComptesUtilisateursStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';

import { FilterDashboardComptesUtilisateurs } from './Dashboard/DashboardHeader/types';
import DashBoardTable from './Dashboard/DashboardTable/DashboardTable';
import { defaultFilterValue } from './common';

const DashboardComptes: React.FC = () => {
  const user = useUserStore();

  const [filter, setFilter] = useState<
    Partial<FilterDashboardComptesUtilisateurs>
  >(defaultFilterValue(user));

  return (
    <ComptesUtilisateursFilterProvider
      value={{ filter: filter, setFilter: setFilter }}
    >
      <DashBoardTable />
    </ComptesUtilisateursFilterProvider>
  );
};

export default DashboardComptes;
